/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Expires_LabelInputs */

const en_admin_invite_codes_expires_label = /** @type {(inputs: Admin_Invite_Codes_Expires_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires at (optional)`)
};

/**
* | output |
* | --- |
* | "Expires at (optional)" |
*
* @param {Admin_Invite_Codes_Expires_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_expires_label = /** @type {((inputs?: Admin_Invite_Codes_Expires_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Expires_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_expires_label(inputs)
});
export { admin_invite_codes_expires_label as "admin.invite_codes.expires_label" }